export function formatLegDepTimeDisplay(legTime) {
    if (legTime == null || String(legTime).trim() === "") return "-";
    const s = String(legTime).trim();
    const match = s.match(/^(\d{1,2}):(\d{2})(?::\d{2})?/);
    if (match) return `${match[1].padStart(2, "0")}:${match[2]}`;
    return s;
}
